import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";

import { graphql } from "@repo/graphql-types/gql";
import Left from "@repo/icons/default/Left";

import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { ServicePreferenceDataSection } from "@/components/profile/sections/service-preferences-data-section";
import { useGraphQL } from "@/hooks/use-graphql.ts";

const ServicePreferencesPageQuery = graphql(/* GraphQL */ `
  query ServicePreferencesPageQuery {
    usuarios {
      ...ServicePreferenceDataSectionFragment
    }
  }
`);

const ServicePreferencesPage = (): JSX.Element => {
  const queryResult = useGraphQL(ServicePreferencesPageQuery);

  const { data } = queryResult;
  const usuario = data?.usuarios[0];

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Preferências de atendimento" />
      </HeaderRoot>
      <Page className="px-6 py-8">
        <AsyncDataWrapper {...queryResult}>
          <div className="flex flex-col gap-8">
            {usuario ? <ServicePreferenceDataSection data={usuario} /> : null}
          </div>
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/schedule-options/service-preferences/")({
  component: ServicePreferencesPage,
});
